import React from 'react'
import { Icon, Label, Button } from 'semantic-ui-react'
import Rating from 'react-rating'

import Eventos from '../../services/Eventos'
import Mensagem from '../Sistema/Mensagem'
import Mensagens from '../../Mensagens';

class Nps extends React.Component {

    arrayCores = ["#b72025"//0
        , "#d62027"//1
        , "#f05223"//2
        , "#f36f21"//3
        , "#faa823"//4
        , "#ffca27"//5
        , "#ecdb12"//6
        , "#e8e73d"//7
        , "#c5d92d"//8
        , "#afd136"//9
        , "#64b64d"];//10

    constructor(props) {
        super(props)

        this.state = {
            idInscricaoCongresso: props.inscricao.idInscricaoCongresso,
            empty: [],
            full: [],
            icExibeConfirmar: props.inscricao.nuEscalaNPS !== '',
            value: props.inscricao.nuEscalaNPS !== '' ? parseInt(props.inscricao.nuEscalaNPS,2) : undefined,
            loading: false,
            mensagem: undefined,
            icAvaliado: props.inscricao.nuEscalaNPS !== ''
        }
    }

    componentDidMount() {

        let arrayEmpty = []
        let arrayFull = []



        this.arrayCores.forEach((item, i) => {
            arrayEmpty.push(
                <span className='nps'>
                    <Icon style={{ color: item }} circular bordered name='circle outline' /><br />
                    <span className='npsIconLabel' >{i}</span>
                </span>
            )
            arrayFull.push(
                <span className='nps'>
                    <Icon style={{ color: item }} circular bordered name='circle' /><br />
                    <span className='npsIconLabel' >{i}</span>
                </span>
            )
        })

        this.setState({
            ...this.state,
            empty: arrayEmpty,
            full: arrayFull
        })

    }

    render() {

        
        return <div>
            {this.props.inscricao.icMarcadaPresenca &&
                <div>
                    <Rating
                        initialRating={this.state.value}
                        start={0}
                        stop={11}
                        emptySymbol={this.state.empty}
                        fullSymbol={this.state.full}
                        readonly={this.state.icAvaliado}
                        onChange={(rate) => this.onChange(rate)}
                    />
                    {this.state.mensagem &&
                        <Mensagem error
                            Content={this.state.mensagem}></Mensagem>
                    }
                    {this.state.icExibeConfirmar &&
                        <Button onClick={() => this.handleAvaliacao()} loading={this.state.loading} disabled={this.state.icAvaliado} className='button type1'>
                            <Button.Content >
                                {this.state.icAvaliado && <Icon name='check' />}
                                {!this.state.icAvaliado && Mensagens.b19}
                                {this.state.icAvaliado &&  Mensagens.b20}
                            </Button.Content>
                        </Button>
                    }

                </div>
            }
            {!this.props.inscricao.icMarcadaPresenca &&
                <Label><Icon name='ticket' disabled />{Mensagens.m57}</Label>
            }
        </div>
    }

    onChange = (index) => {
        this.setState({
            ...this.state,
            icExibeConfirmar: true,
            value: index
        })
    }

    handleAvaliacao = () => {

        this.setState({
            ...this.state,
            loading: true
        }, () => {

            Eventos.setEventoNPS(this.state.idInscricaoCongresso, this.state.value - 1).then(result => {

                this.setState({
                    ...this.state,
                    loading: false,
                    icAvaliado: result.sucesso,
                    mensagem: result.sucesso ? '' : result.Mensagem
                })

                if (this.props.onEndAvaliacaoNPS)
                    this.props.onEndAvaliacaoNPS()

            })
        })
    }

}
export default Nps


// WEBPACK FOOTER //
// ./src/components/Eventos/Nps.js